'use client';

import React, { useMemo } from 'react';
import { useTranslations } from 'next-intl';
import { PerformanceLabTypeformSnippet } from 'components/performance-lab/PerformanceLabTypeformSnippet';
import { buildTypeformTrackingFromUrl } from 'lib/analytics/buildTypeformTrackingParams';
import { PerformanceLabModalBodyScrollLock } from '../PerformanceLabModalBodyScrollLock';
import { GLP_SIGNUP_TYPEFORM_ID } from './glpTypeform';
import styles from './GlpSignUpTypeformModal.module.css';

export const GlpSignUpTypeformModal: React.FC = () => {
  const t = useTranslations('performance-lab');

  const trackingParams = useMemo(
    () =>
      buildTypeformTrackingFromUrl({
        utm_source: 'performance_lab_glp',
        utm_medium: 'web',
        utm_campaign: 'glp_signup',
      }),
    [],
  );

  return (
    <PerformanceLabModalBodyScrollLock>
      <div className={styles.modalRoot}>
        <div className={styles.typeformContainer}>
          <PerformanceLabTypeformSnippet
            typeformId={GLP_SIGNUP_TYPEFORM_ID}
            frameTitle={t('glp.signUpTypeform.frameTitle')}
            className="typeform-container"
            trackingParams={trackingParams}
          />
        </div>
      </div>
    </PerformanceLabModalBodyScrollLock>
  );
};
